import { useEffect, useState } from 'react';
import { agenticRootUrl } from '@/services/agenticApi';

export interface AgentStatus {
  id: string;
  display_name: string;
  provider: string;
  status: 'online' | 'offline' | 'no key';
}

/**
 * Pings the agents-core /health endpoint and returns per-agent status.
 */
export const useApiHealth = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [agents, setAgents] = useState<AgentStatus[]>([]);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const res = await fetch(`${agenticRootUrl}/health`);
        if (!cancelled) {
          setIsConnected(res.ok);
          if (res.ok) {
            const data = await res.json();
            setAgents(data.agents ?? []);
          } else {
            setAgents([]);
          }
        }
      } catch {
        if (!cancelled) {
          setIsConnected(false);
          setAgents([]);
        }
      }
    };
    check();
    const interval = setInterval(check, 30000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return { isConnected, agents };
};
